import React from 'react';
import './styles/DashboardLayout.scss';


const DashboardLayout = ({ children }) => {
    return (
        <div className="dashboardLayout">
            <div className="container">
                {children}
            </div>
        </div>
    );
};

export default DashboardLayout;
